export type TipoListaFusionInformativa = 'NORMAL' | 'REVENTADO';

export interface ListaFusionInformativaInput {
  tipo: TipoListaFusionInformativa;
  rows: any[];
}

export interface FilaFusionInformativa {
  numero: string;
  monto_r1: number;
  monto_r2: number;
  monto_total: number;
}

const normalizarNumero = (value: unknown): string => {
  const raw = String(value ?? '').trim();
  if (!/^\d+$/.test(raw)) return '';
  return raw.padStart(2, '0').slice(-2);
};

const toNumber = (value: unknown): number => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const fusionarListasInformativas = (
  listaA: ListaFusionInformativaInput,
  listaB: ListaFusionInformativaInput,
): FilaFusionInformativa[] => {
  const acc = new Map<string, FilaFusionInformativa>();

  const ensureRow = (numero: string): FilaFusionInformativa => {
    const key = normalizarNumero(numero);
    const existing = acc.get(key);
    if (existing) return existing;
    const row = {
      numero: key,
      monto_r1: 0,
      monto_r2: 0,
      monto_total: 0,
    };
    acc.set(key, row);
    return row;
  };

  const sumarLista = (lista: ListaFusionInformativaInput) => {
    for (const item of lista.rows || []) {
      const numero = normalizarNumero(item.numero);
      if (!/^\d{2}$/.test(numero)) continue;
      const row = ensureRow(numero);
      if (lista.tipo === 'NORMAL') {
        row.monto_r1 += toNumber(item.vendido ?? item.monto_total ?? item.monto);
      } else {
        row.monto_r1 += toNumber(item.vendido_rev1);
        row.monto_r2 += toNumber(item.vendido_rev2);
      }
      row.monto_total = row.monto_r1 + row.monto_r2;
    }
  };

  sumarLista(listaA);
  sumarLista(listaB);

  return Array.from(acc.values())
    .filter((row) => row.monto_total > 0)
    .sort((a, b) => a.numero.localeCompare(b.numero));
};
